import React from 'react'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'

export default function Selector({
  top,
  bottom,
  onClick = () => {},
  selected = false
}: {
  top: string
  bottom: string
  onClick?: () => void
  selected?: boolean
}) {
  const isDarkMode = useIsDarkMode()
  return (
    <div
      onClick={onClick}
      className={classnames({
        'box-content px-1 rounded min-w-[70px] w-full h-[48px] flex flex-col items-center justify-center text-center transition ease-out duration-150 cursor-pointer':
          true,
        'bg-gray-100 hover:bg-gray-200': !isDarkMode && !selected,
        'bg-gray-800 text-white': !isDarkMode && selected,
        'bg-gray-600 hover:bg-gray-500 text-white': isDarkMode && !selected,
        'bg-gray-100 text-black': isDarkMode && selected
      })}>
      <p className="text-xs">{top}</p>
      <p className="text-xs font-semibold">{bottom}</p>
    </div>
  )
}
